export default __webpack_public_path__ + "static/logoNew-149a9f6d6fde10ddb427670f6fae3ccd.png";